module.exports = __webpack_public_path__ + "static/media/saha@2x.e3773b6b.png";